// Файл DocViewer.js

/**
 * Компонент показывает безопасный fallback для старого формата DOC и предоставляет его скачивание пользователю.
 */

//
// Старый бинарный формат Word (.doc) надёжно не отображается
// в браузере без серверной конвертации. Поэтому показываем
// понятное сообщение и даём скачать файл (fallback).

import { useAccess } from '../../services/AccessContext';



const DocViewer = ({ blob, fileName }) => {
    const { hasAccess } = useAccess();
    const allow_download = hasAccess('4.5');
    const handleDownload = () => {
        if (!blob) {
            return;
        }

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', fileName || 'document.doc');

        document.body.appendChild(link);
        link.click();
        link.remove();

        URL.revokeObjectURL(url);
    };

    return (
        <div className="file-viewer__message flex-column flex-align-center">
            <p className="file-viewer__text">
                Старый формат Word (.doc) не отображается
                в браузере напрямую. Файл можно скачать
                и открыть в Word.
            </p>

            {allow_download && (
                <button
                    type="button"
                    className="file-viewer__download-btn"
                    onClick={handleDownload}
                    disabled={!blob}
                >
                    Скачать файл
                </button>
            )}
        </div>
    );
};


export default DocViewer;
